import { render } from "./CardSkeleton.vue?vue&type=template&id=775f11ed&ts=true"
import script from "./CardSkeleton.vue?vue&type=script&lang=ts"
export * from "./CardSkeleton.vue?vue&type=script&lang=ts"

import "./CardSkeleton.vue?vue&type=style&index=0&id=775f11ed&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__